import AssetHelper from "../../AssetHelper";

import './MatchVideo.css'
import {useEffect, useState} from "react";
import ReactPlayer from "react-player/file";
import play from "../../sounds";

const videoNames = ['red', 'blue', 'tie', 'SandRising'] as const;
export type VideoColors = typeof videoNames[number];

let preloadComplete = false;
export const videos : Partial<Record<VideoColors, string>> = {}

export function preloadVideos() {
    if(preloadComplete) {
        return;
    }

    Promise.all(videoNames.map(async(key) => {
        const res =  await fetch(AssetHelper.syncPath(`video/${key}.webm`));
        videos[key] = window.URL.createObjectURL(await res.blob());
    })).then(() => {
        preloadComplete = true
        const myEvent = new Event('videoPreloadComplete')
        document.dispatchEvent(myEvent)
    });
}

export default function MatchVideo({video, mute, disabled, onFinish} : {
    video: VideoColors,
    mute: boolean,
    disabled: boolean,
    onFinish?: () => void
}) {
    const [videoBlob, setVideoBlob] = useState(videos[video])
    const [visible, setVisible] = useState(true)

    useEffect(() => {
        if(videoBlob) {
            return;
        }

        document.addEventListener('videoPreloadComplete', () => {
            setVideoBlob(videos[video])
        })

    }, [setVideoBlob])

    if(!videoBlob || disabled) {
        return null;
    }

    return <ReactPlayer playing url={videoBlob} width={"1920px"} height={"1080px"}
                        style={{position: "fixed", left: 0, top: 0, zIndex: 10, opacity: visible ? 1 : 0}}
                        className={"matchResultVideo"}
                        muted={mute}
                        onError={(e) => { console.log(e); setVisible(false) }}
                        onEnded={() => {
                            if(!mute) {
                                play('results');
                            }
                            setVisible(false)
                            if(onFinish) {
                                onFinish()
                            }
                        }}/>
}